<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersApi from "@/services/users-api";
import Swal from "sweetalert2";
import CountriesApi from "@/services/countries-api";
import i18n from '../../../i18n';


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Profil",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout},
  mounted(){
    this.getLogin()

    
    // this.getCountries()
  },
  data() {
    return {
      paymentList: [{name:'', value: 0 }, {name:'', value: 1},{name:'', value: 2}],
      deliveryList:[{name:'', value: 0 }, {name:'', value: 1},{name:'', value: 2}],
      citiesList:[],
      countriesList:[],
      selectedCountry:null,
      profilInfo : {
        name:'',
        addresses: [''],
        phone:'',
        country:'',
        city:'',
        mail:'',
        bank:'',
        rib:'',
        taxRefNumber: '',
        socialReason:'',
      },
      profil:{
        name:'',
        addresses: [''],
        phone:'',
        country:'',
        city:'',
        mail:'',
        bank:'',
        rib:'',
        taxRefNumber: '',
        socialReason:'',
      },

      selected:{id:null, 
            status:1,
            name: null,
            addresses: [''],
            country:null,
            city:null,
            phone:null,
            secondPhone:null,
            mail:null,
            bank:null,
            rib: null,
            taxRefNumber: null,
            socialReason:null,
      },
      login:'',
      oldPassword:'',
      newPassword:'',
      confirmationPassword:'',
      changeLogo:null,
      showContactModal:false,
      showForm:false,
      selectedContact: {id:'', firstName:'', lastName:'', phone:'', email:'', position:'' },
      
      addInputAdress:null,
    };
  },

  
  
  methods:{
    getLogin(){
      UsersApi.getLogin().then(
        result => {
          this.login=result
        }
      )
    },

    ChangePassword() {
      UsersApi.ChangePassword(this.oldPassword, this.newPassword, this.confirmationPassword)
      .then(
        result => {
          if (result) {
            this.oldPassword = '';
            this.newPassword = '';
            this.confirmationPassword = '';
          }
        }
      )
    },

    getProfilInfo(){
      UsersApi.getProfilInfo().then(
        result => {
          this.profilInfo=result;
        }
      )
    },
    changeProfilInfo(){
      Swal.fire({
      title:  i18n.t('profil.swal.title') ,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#d11010",
      cancelButtonColor: "#34c38f",
      cancelButtonText:  i18n.t('profil.swal.cancelButtonText') ,
      confirmButtonText: i18n.t('profil.swal.confirmButtonText') ,
      }).then(result => {
          if (result.value) {
              UsersApi.changeProfilInfo(this.profilInfo)
          }
      })
    },
        
    onImageUpload(event) {
        this.changeLogo=event.target.files[0];
        this.uploadImage() 
    },

    uploadImage(){
      const fd = new FormData();
      fd.append('file', this.changeLogo, this.changeLogo.name)
      UsersApi.uploadImage(fd).then(
        res => {
          if(res){
            this.getProfilInfo()
          }
        }
      )
    },
    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
        var id = this.selected ? (this.selected.country ? this.selected.country.id : null) : null
        if(id == null){
            this.citiesList=[]
            return;
        }
       CountriesApi.getCities(id).then(
          result => {
            this.citiesList = result
        })
     },
     addAddress() {
        this.profil.addresses.push('');
        this.addInputAdress=true;
    },
    deleteAddress(index) {
        this.profil.addresses.splice(index, 1);
      },

    deleteImage() {
      Swal.fire({
          title: "Supprimer votre logo ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d11010",
          cancelButtonColor: "#34c38f",
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, supprimer!"
      }).then(result => {
          if (result.value) {
              UsersApi.deleteImage()
              .then(() =>{
                   this.getProfilInfo()
                  }) 
          }
      })
    },
    addNew(){
      this.showForm =true;
    } ,
    hideForm(){
      this.showForm =false;
    },
    cancelEdit(){
      this.selectedContact.id=null
      this.selectedContact.firstName=''
      this.selectedContact.lastName=''
      this.selectedContact.phone=''
      this.selectedContact.email=''
      this.selectedContact.position=''
    },
    editContact(contact){
      this.showForm =true;
      this.cancelEdit();
      this.selectedContact.id=contact.id
      this.selectedContact.firstName=contact.firstName
      this.selectedContact.lastName=contact.lastName
      this.selectedContact.phone=contact.phone
      this.selectedContact.email=contact.email
      this.selectedContact.position=contact.position
    },
    saveContact(){
      UsersApi.saveContact(this.selectedContact).then(
        ()=> {
          this.getProfilInfo()
          this.cancelEdit()
          this.hideForm()
        }
      )
    },

    removeContact(contact){
      Swal.fire({
        title: "Supprimer ?",
        html: contact.firstName+' '+contact.lastName,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d11010",
        cancelButtonColor: "#34c38f",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, supprimer!"
    }).then(result => {
        if (result.value) {
            UsersApi.removeContact(contact)
            .then(() =>{
                  this.getProfilInfo()
                }) 
        }
    })

    },

  }
}
</script>
<template>
    <Layout>
      <div class="row pt-4 p-sm-4">
        <div class="col-12 card border h-100">
          <div class="card-body">
            <h4 class="card-title pt-2 pb-4 text-dark font-size-18 ">{{$t('profil.passwordTitle')}}</h4>
                <div class="row">
                  <b-form class="col-12">
                    <div class="form-group row mb-3">
                        <label class="col-md-3 col-form-label" for="name" >{{$t('profil.user')}}</label>
                        <div class="col-md-9">
                          <input type="text" name="login" class="form-control" style="background-color: #f0f3ec;" v-model="login" disabled/>
                        </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="pwd">{{$t('profil.oldPassword')}}</label>
                      <div class="col-md-9">
                        <input
                          id="Oldpwd"
                          type="password"
                          v-model="oldPassword"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="pwd">{{$t('profil.newPassword')}}</label>
                      <div class="col-md-9">
                        <input
                          id="Newpwd"
                          type="password"
                          v-model="newPassword"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="confirmpwd">{{$t('profil.confirmationPassword')}}</label>
                      <div class="col-md-9">
                        <input
                          id="confirmpwd"
                          type="password"
                          v-model="confirmationPassword"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                    </div>
                    <div class="row mt-4 mb-0" style="float: right; text-align: right;">
                      <b-button  class="ml-2 " variant="outline-primary" style="display: inline-block" @click="ChangePassword()" >
                        <span class="font-weight-bold">{{$t('buttons.save')}}</span>
                      </b-button>
                    </div>                    
                  </b-form>
                  <!-- end col -->
                </div>
                <!-- end row -->
          </div>
        </div>
      </div>
    </Layout>
</template>